import { IBatch } from "../../models/wms/batch/response";
import { currencyFormat } from "./format";

/**
 * A batch cost with its own symbol. The currency is stamped on the batch at
 * creation and never moves again, so it is read from `purchasePriceIsDollar`
 * and never re-derived from the product's pricing today — doing that would
 * rewrite the cost of past purchases every time someone edits a price.
 *
 * Batches entered before the field existed carry no price at all, which is why
 * this returns a dash instead of a zero.
 */
export const formatBatchPurchasePrice = (
  price: number | null | undefined,
  isDollar: boolean | undefined,
  syrianPoundLabel: string,
): string => {
  if (price === null || price === undefined) return "—";

  const amount = Number(price);
  if (!Number.isFinite(amount)) return "—";

  return currencyFormat(amount, isDollar ? "$" : syrianPoundLabel);
};

export const formatBatchPurchasePriceOf = (
  batch: Pick<IBatch, "purchasePrice" | "purchasePriceIsDollar">,
  syrianPoundLabel: string,
): string =>
  formatBatchPurchasePrice(
    batch?.purchasePrice,
    batch?.purchasePriceIsDollar,
    syrianPoundLabel,
  );
